<template>
  <form @submit.prevent="promiseDeleteIntegration = handleDelete()">
    <b-modal v-model="showDeleteModal"
             title="Delete Integration"
             @hide="hideModal">
      <p>
        This will permanently delete the <b>{{integration.name}}</b> integration.
      </p>

      <template slot="modal-footer">
        <button type="button" class="btn btn-secondary" @click="hideModal">Cancel</button>
        <!-- "Ladda button" breaks disabling button -->
        <button type="submit" class="mr-0 btn btn-danger"
                v-busy-button="promiseDeleteIntegration">Delete
        </button>
      </template>
    </b-modal>
  </form>
</template>

<script>
  import integrationService from '@/services/amio-api/integration.service'
  import notificationService from '@/services/notification/notification.service'

  export default {
    store: {
      showDeleteModal: 'administration.integrationDetail.showDeleteModal'
    },

    props: {
      integration: {
        type: Object,
        required: true
      }
    },

    data() {
      return {
        name: '',
        promiseDeleteIntegration: null
      }
    },

    methods: {
      hideModal() {
        this.clearData()
        this.showDeleteModal = false
      },

      clearData() {
        this.name = ''
        this.promiseDeleteIntegration = null
      },

      handleDelete() {
        return integrationService.delete(this.integration.id)
          .then(() => {
            this.$emit('integration-deleted', this.integration)
            notificationService.success('Integration was successfully deleted')
          })
          .then(this.hideModal)
          .catch(this.clearData)
      }
    }
  }
</script>
